import { render } from "./CustomizeForm.vue?vue&type=template&id=6676128d"
import script from "./CustomizeForm.vue?vue&type=script&lang=js"
export * from "./CustomizeForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__